(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('AdminClusterActionsController', AdminClusterActionsController);

    function AdminClusterActionsController($scope, $state, $stateParams, $translate, logger, config, modalDialogService, notifyingService, dataService) {
        var vm = this;
        var _lazyLoadClusterActions = _.debounce(_loadClusterActions, 300);

        vm.isAdmin = config.settings.user.isAdmin;
        vm.disableIndividualAssignment = config.settings.custom.disableIndividualAssignment;

        vm.gridOptions = {
            enableFiltering: true,
            enableSorting: false,
            appScopeProvider: vm,
            onRegisterApi: function (gridApi) {
                vm.gridOptions.gridApi = gridApi;
            },
            columnDefs: [
                {
                    displayName: $translate.instant('skill'),
                    name: 'actionName',
                    enableColumnMenu: false
                },
                {
                    name: 'buttons',
                    displayName: '',
                    width: 200,
                    cellTemplate: '/app/templates/clusteractions/clusteractions-grid-buttons.tpl.html',
                    enableColumnMenu: false,
                    enableFiltering: false
                }
            ]
        };

        vm.addClusterAction = addClusterAction;
        vm.changeCategory = changeCategory;
        vm.deleteClusterAction = deleteClusterAction;
        vm.editClusterAction = editClusterAction;
        vm.isCurrentState = isCurrentState;
        vm.manageFunctions = manageFunctions;
        vm.manageIndividuals = manageIndividuals;

        notifyingService.subscribe($scope, 'clusteraction-updated', function (event, args) {
            if (!vm.selectedClusterAction) return;
            if (args.id !== vm.selectedClusterAction.id) return;
            
            vm.selectedClusterAction.actionName = args.actionName;
        });

        $scope.$watch('vm.cluster', () => {
            _loadClusterActions();
        });

        function _loadClusterActions() {
            vm.gridOptions.data = [];

            if (!vm.cluster) return;

            dataService
                .getClusterActions(vm.cluster.id)
                .then(clusterActions => {
                    vm.gridOptions.data = clusterActions;
                    vm.gridOptions.gridApi.core.handleWindowResize();
                });
        }

        function addClusterAction() {
            return modalDialogService.openAddClusterActionDialog(vm.cluster)
                .then(result => {

                    var newClusterActions = _.union([], vm.gridOptions.data);
                    newClusterActions.push(result.clusterAction);

                    vm.gridOptions.data = _.sortBy(newClusterActions, function (item) { return item.actionName.toLowerCase(); });
                    vm.gridOptions.gridApi.core.handleWindowResize();

                    if (result.addActivities) {
                        $state.go('app-main.admin-clusteractions.edit-clusteraction', { id: result.clusterAction.id });
                    }
                });
        }

        function changeCategory(entity) {
            return modalDialogService
                .openChangeClusterActionClusterDialog(entity)
                .then(clusterAction => {
                    if (clusterAction.clusterId !== entity.clusterId) {
                        vm.gridOptions.data.splice(vm.gridOptions.data.indexOf(entity), 1);
                    }
                });
        }

        function deleteClusterAction(entity) {
            modalDialogService.confirmDelete('delete_clusteraction', 'confirm_delete_clusteraction', () => {
                dataService.deleteClusterAction(entity.id)
                    .then(result => {
                        logger.success('successfully_deleted');
                        vm.gridOptions.data.splice(vm.gridOptions.data.indexOf(entity), 1);
                    });
            });
        }

        function editClusterAction(entity) {
            vm.selectedClusterAction = entity;

            $state.go('app-main.admin-clusteractions.edit-clusteraction', { id: entity.id });
        }

        function isCurrentState() {
            return $state.is('app-main.admin-clusteractions');
        }

        function manageFunctions(entity) {
            $state.go('app-main.admin-clusteractions.functions', { id: entity.id });
        }

        function manageIndividuals(entity) {
            $state.go('app-main.admin-clusteractions.individuals', { id: entity.id });
        }
    }
})();